export { default as DocumentTitle } from './document-title';
